module.exports = __webpack_public_path__ + "static/media/LosAngeles.cdc9157f.jpg";